export default __webpack_public_path__ + "static/media/tracking-logo-ws.d092ea96.png";